import { render, staticRenderFns } from "./MenuItemEle.vue?vue&type=template&id=094ca3d1&scoped=true&"
import script from "./MenuItemEle.vue?vue&type=script&lang=js&"
export * from "./MenuItemEle.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemEle.vue?vue&type=style&index=0&id=094ca3d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094ca3d1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
